import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Select2 from 'react-select2-wrapper';
import {Typeahead} from 'react-bootstrap-typeahead';

import 'react-bootstrap-typeahead/css/Typeahead.css';

import LoadingOverlay from '../elements/LoadingOverlay';

class AddLocationDialog extends Component {
    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.componentWillMount = this.componentWillMount.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
    }

    componentWillMount() {
        document.addEventListener('click', this.handleOutsideClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick, false);
    }

    handleClick(e) {
        let node = e.target;
        let found = false;

        // ignore clicks on the component itself
        while (node && node.classList) {
            if (node.classList.contains("modal-content")) {
                found = true;
            }

            node = node.parentNode;
        }
        if (!found) {
            this.props.cancel();
            return true;
        }
        return false;
    }

    handleInputChange(e) {
        this.props.changeValue(e.target.name, e.target.value);
    }

    handleCheckboxChange(e) {
        this.props.changeValue(e.target.name, !this.props.addShift[e.target.name]);
    }

    handleFormSubmit(e) {
        e.preventDefault();
        const { addLocation } = this.props;
        this.props.save({
            name: addLocation.name,
            groupName: addLocation.groupName,
            workType: addLocation.workType
        })
    }

    render() {
        const { addLocation, t } = this.props;
        return (
            <div className="AddLocationDialog modal inmodal in" tabIndex="-1" role="dialog" style={{display: 'block'}} ref={node => { this.node = node; }} onClick={this.handleClick}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button className="close" onClick={this.props.cancel}>
                                <span>x</span>
                            </button>
                            <h4 className="modal-title">
                                {t('addLocationDialog.title')}
                            </h4>
                        </div>
                        <div className={addLocation.loading ? 'LoadingOverlayContainer' : ''}>
                            {addLocation.loading ? (
                                <LoadingOverlay/>
                            ) : null}
                            <form onSubmit={this.handleFormSubmit}>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div
                                                className={"form-group" + ((addLocation.errors && addLocation.errors.name) ? ' has-error' : '')}>
                                                <label>{t('addLocation.name.label')}</label>
                                                <input type="text" name="name" value={addLocation.name} onChange={this.handleInputChange} className="form-control"/>

                                                {(addLocation.errors && addLocation.errors.name) ? (
                                                    <span className="help-block">
                                                        {t('addLocation.name.error.' + addLocation.errors.name)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div
                                                className={"form-group" + ((addLocation.errors && addLocation.errors.groupName) ? ' has-error' : '')}>
                                                <label>{t('addLocation.groupName.label')}</label>
                                                <Typeahead newSelectionPrefix="neu anlegen: " options={addLocation.availableLocationGroups ? addLocation.availableLocationGroups : null} allowNew={true} onBlur={(e) => {this.props.changeValue('groupName',(e.target.value))}} onChange={(value) => {if(value && value[0]) { this.props.changeValue('groupName', (value && value[0]) ? typeof value[0] === 'string' ? value[0] : value[0].label : '' ) }}} value={addLocation.groupName}/>


                                                {(addLocation.errors && addLocation.errors.groupName) ? (
                                                    <span className="help-block">
                                                        {t('addLocation.groupName.error.' + addLocation.errors.groupName)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div
                                                className={"form-group" + ((addLocation.errors && addLocation.errors.workType) ? ' has-error' : '')}>
                                                <label>{t('addLocation.workType.label')}</label>
                                                <Select2 data={addLocation.availableWorkTypes.map((el) => {
                                                    return {
                                                        text: t('addLocation.workType.' + el.name), id: el.id
                                                    }
                                                })} value={addLocation.workType} onChange={this.handleInputChange} name="workType"
                                                         options={{placeholder: t('addLocation.workType.placeholder')}}
                                                         className="width-100p block"/>


                                                {(addLocation.errors && addLocation.errors.workType) ? (
                                                    <span className="help-block">
                                                        {t('addLocation.workType.error.' + addLocation.errors.workType)}
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-default" type="button" disabled={addLocation.loading} onClick={this.props.cancel}>
                                        {t('default.cancel')}
                                    </button>
                                    <button className="btn btn-primary" type="submit" disabled={addLocation.loading}>
                                        {t('default.save')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate()(AddLocationDialog);